<!--
 * @FileDescription: 部门管理（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: ryb（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="page-container department">
      <div class="page-container-height">
          <div class="department-left">
              <div class="department-left-top">
                  全部部门
                  <a-icon  type="plus-circle" theme="filled"  :style="{  color: '#387BFC' }" @click="onAddDepart()" />
              </div>
              <a-directory-tree multiple defaultExpandAll @select="onSelect">
                  <a-tree-node  v-for="(item,index) in treeList" :key="index"   >
                      <span slot="title" class="tree-span" @mouseover="mouseOver($event,item)" @mouseleave="mouseLeave($event,item)">
                          <span v-if="!item.isActive">{{item.name}}</span>
                          <a-input v-model="item.name" class="tree-input" allowClear  v-if="item.isActive" v-focus @blur="onBlur(item)" @pressEnter="pressEnter(item)"></a-input>
                          <img src="@/assets/image/bianji@2x.png" v-if="item.isCheck" @click="onEditTree(item)"/>
                      </span>
                  </a-tree-node>
              </a-directory-tree>
          </div>
          <div class="department-right">
              <div class="department-right-top">
                  <div class="department-top-left">
                      <a-input placeholder="请输入关键字查询" v-model="inputvalue" class="department-input"></a-input>
                      <a-button type="primary" class="button-search" @click="onSearch()">搜索</a-button>
                  </div>
                  <a-button class="btn-add-default"
                            icon="plus" @click="onEdit(1)">新增员工</a-button>
              </div>
              <a-table :columns="columns"
                       :dataSource="dataSource"
                       :pagination="pagination"
                       bordered
                       @change="handleTableChange"
                       class="table-height"
                       rowKey="key">
                  <template slot="operation" slot-scope="text, record">
                      <div class="operation">
                          <div class="operation-left" @click="onEdit(2,record)">编辑</div>
                          <div class="operation-right operation-item">
                              <a-popconfirm
                                      v-if="dataSource.length"
                                      title="确定删除?"
                                      @confirm="() => onDelete(record)"
                              >
                                  <a href="javascript:;" >
                                      <img src="@/assets/image/cha_shanchu_color.png" class="operation-item-img" />
                                      <img src="@/assets/image/cha_shanchu.png" class="operation-item-img1"/>
                                  </a>
                              </a-popconfirm>
                          </div>
                      </div>
                  </template>
              </a-table>
          </div>
      </div>
      <model :width="660" :height="300" :title="title" ref="model" @onCofrim="onCofrimForm" :isShow="isShowModel" @onCancel="onCancel">
          <a-form :form="form"
                  :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 16 }"
          >
              <a-form-item label="部门名称" style="padding-top: 50px">
                  <a-input placeholder="请输入部门名称"
                           v-decorator="['name', { rules: [{ required: true, message: '请输入部门名称' }] }]" />
              </a-form-item>
          </a-form>
      </model>
      <model :width="800" :height="800" :title="title1" ref="model1" @onCofrim="onCofrimForm1" :isShow="isShowModel1" @onCancel="onCancel1" class="model-form">
          <a-form :form="form1"
                  :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 12 }"
                  class="display-flex"
          >
              <div class="form-left">
                  <a-form-item label="员工姓名">
                      <a-input placeholder="请输入员工姓名"
                               v-decorator="['name', { rules: [{ required: true, message: '请输入员工姓名' }] }]" />
                  </a-form-item>
                  <a-form-item label="员工电话">
                      <a-input placeholder="请输入员工电话"
                               v-decorator="['phone', { rules: [{ required: true, message: '请输入员工电话' }] }]" />
                  </a-form-item>
                  <a-form-item label="员工工号">
                      <a-input placeholder="请输入员工工号"
                               v-decorator="['data1', { rules: [{ required: false }] }]" />
                  </a-form-item>
                  <a-form-item label="入职日期">
                      <a-date-picker v-if="!addNew" @change="onChangeData" placeholder="请选择入职日期"    v-decorator="['time', { rules: [{ required: true,message:'请选择入职时间' }] }]"/>
                      <a-date-picker v-else @change="onChangeData" placeholder="请选择入职日期" :defaultValue="moment(datetime, 'YYYY-MM-DD')"   v-decorator="['time', { rules: [{ required: true,message:'请选择入职时间' }] }]"/>
                  </a-form-item>
                  <a-form-item label="部门">
                      <a-select  v-decorator="['data2',{ rules: [{ required: false}] },]"
                                 placeholder="请选择部门"
                      >
                          <a-select-option value="销售部">
                              销售部
                          </a-select-option>
                          <a-select-option value="客服部">
                              客服部
                          </a-select-option>
                      </a-select>
                  </a-form-item>
                  <a-form-item label="薪资待遇">
                      <a-input placeholder="请输入薪资待遇"
                               v-decorator="['data3', { rules: [{ required: false }] }]" />
                  </a-form-item>
                  <a-form-item label="是否正式">
                      <a-radio-group @change="onChangeRadio"  :defaultValue="default1" v-decorator="['data4', { rules: [{ required: false }] }]">
                          <a-radio :value="0">实习</a-radio>
                          <a-radio :value="1">正式</a-radio>
                      </a-radio-group>
                  </a-form-item>
                  <a-form-item label="状态">
                      <a-radio-group @change="onChangeRadio1" :defaultValue="default2" v-decorator="['data5', { rules: [{ required: false }] }]">
                          <a-radio :value="1">在职</a-radio>
                          <a-radio :value="2">离职</a-radio>
                      </a-radio-group>
                  </a-form-item>
                  <a-form-item label="入职合同">
                     <div class="down-up" v-if="!addNew">
                         <a-icon type="upload" class="down-up-icon" />
                         <span>上传附件</span>
                         <input type="file" ref="thumbnail" accept="image/*" class="input-file"/>
                     </div>
                      <div class="down-up" v-else>
                          <a-icon type="download" class="down-up-icon" />
                          <span>下载附件</span>
                      </div>
                  </a-form-item>
              </div>

              <div class="form-left">
                  <a-form-item label="身份证号">
                      <a-input placeholder="请输入员工身份证号" :maxLength="18"
                               v-decorator="['data6', { rules: [{ required: false }] }]" />
                  </a-form-item>
                  <a-form-item label="学历">
                      <a-select  v-decorator="['data7',{ rules: [{ required: false}] },]"
                                 placeholder="请选择部门"
                      >
                          <a-select-option key="初中">
                              初中
                          </a-select-option>
                          <a-select-option key="高中">
                              高中
                          </a-select-option>
                          <a-select-option key="本科">
                              本科
                          </a-select-option>

                      </a-select>
                  </a-form-item>
                  <a-form-item label="专业">
                      <a-input placeholder="请输入专业名称"
                               v-decorator="['data8', { rules: [{ required: false }] }]" />
                  </a-form-item>
                  <a-form-item label="性别">
                      <a-radio-group @change="onChangeRadio2" :defaultValue="default3" v-decorator="['data9', { rules: [{ required: false }] }]">
                          <a-radio :value="0">男</a-radio>
                          <a-radio :value="1">女</a-radio>
                      </a-radio-group>
                  </a-form-item>
                  <a-form-item label="出生年月">
                      <a-date-picker v-if="!addNew" @change="onChangeData1" placeholder="请选择出生年月"   v-decorator="['data10', { rules: [{ required: false}] }]"/>
                      <a-date-picker v-else @change="onChangeData1" :defaultValue="moment(datetime, 'YYYY-MM-DD')" placeholder="请选择出生年月"   v-decorator="['data10', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                  <a-form-item label="籍贯">
                      <a-input placeholder="请输入员工籍贯"
                               v-decorator="['data11', { rules: [{ required: false }] }]" />
                  </a-form-item>
                  <a-form-item label="员工地址">
                      <a-textarea placeholder="请输入员工地址" style="height: 80px!important;width: 200px;max-width: 200px"
                               v-decorator="['data12', { rules: [{ required: false }] }]" />
                  </a-form-item>
                  <a-form-item label="照片">
                      <v-picture v-decorator="['data13', { rules: [{ required: false }] }]" v-if="!addNew"></v-picture>
                      <div v-else class="upload-img">
                          <div class="upload-img-left">
                              <img src="@/assets/image/timg.jpg"/>
                              <div class="upload-delete">
                                  <a-icon type="delete" class="upload-delete-icon" />
                              </div>
                          </div>
                          <div class="upload-more">重新上传
                              <input type="file" ref="thumbnail" accept="image/*" class="input-file"/>
                          </div>
                      </div>
                  </a-form-item>
              </div>
          </a-form>
      </model>
  </div>
</template>
<script>
import model from  '@/components/model'
import picture from "@/components/upload/picture.vue"
import moment from 'moment';
import Vue from 'vue'
export default {
  data () {
    return {
        inputvalue:'',
        title:'新增部门',
        title1:'新增员工',
        datetime:'',
        datatime2:'',
        isShowModel:false,
        form: this.$form.createForm(this),
        isShowModel1:false,
        form1: this.$form.createForm(this),
        treeList:[
            {
                name:'销售部',
                isCheck:false,
                isActive:false,
            },
            {
                name:'总裁办',
                isCheck:false,
                isActive:false,
            },
            {
                name:'客服部',
                isCheck:false,
                isActive:false,
            },
            {
                name:'业务部',
                isCheck:false,
                isActive:false,
            },
            {
                name:'产品部',
                isCheck:false,
                isActive:false,
            },
            {
                name:'设计部',
                isCheck:false,
                isActive:false,
            },
            {
                name:'技术部',
                isCheck:false,
                isActive:false,
            }
        ],
        columns: [
            {
                title: '员工工号',
                key: 'data1',
                align: 'center',
                dataIndex: 'data1',
            },
            {
                title: '员工姓名',
                key: 'data2',
                align: 'center',
                dataIndex: 'data2',
            },
            {
                title: '联系电话',
                dataIndex: 'data3',
                align: 'center',
                key: 'data3',
            },
            {
                title: '部门',
                key: 'data4',
                align: 'center',
                dataIndex: 'data4',
            },
            {
                title: '入职时间',
                key: 'data5',
                align: 'center',
                dataIndex:'data5'
            },
            {
                title: '在职状态',
                key: 'data6',
                align: 'center',
                dataIndex:'data6',
                customRender:res => {
                    if(res == 0){
                        return '在职'
                    }else{
                        return '离职'
                    }
                }
            },
            {
                title: '操作',
                align: 'center',
                dataIndex:'data7',
                scopedSlots: { customRender: 'operation' },
            },
        ],
        dataSource: [
            {
                key: '1',
                data1:'1001',
                data2:'张三',
                data3:'15356144697',
                data4:'技术部',
                data5:'2020-04-20',
                data6:'0'
            },
            {
                key: '2',
                data1:'1001',
                data2:'张三',
                data3:'15356144697',
                data4:'技术部',
                data5:'2020-04-20',
                data6:'1',
            },
            {
                key: '3',
                data1:'1001',
                data2:'张三',
                data3:'15356144697',
                data4:'技术部',
                data5:'2020-04-20',
                data6:'0',
            },
        ],
        tal:2,
        pagination:{
            current: 1,
            pageSize: 5,
            showTotal: (total, range) => {
                return '共' + total +'条数据     ' + '每页'+(range[1]-range[0] + 1)+'条数据 共'+this.tal+'页'
            },
            showQuickJumper: true,
            total:9
        },
        default1:1,
        default2:1,
        default3:0,
        addNew:false,
    }
  },
  components: {
      model,
      'v-picture':picture,
  },
  methods: {
      moment,
    /**
    * @description: 此为方法注释（方法描述）
    * @param {参数类型} 参数名称
    * @return void
    */
      onSelect(keys, event) {
        console.log('Trigger Select', keys, event);
      },
      /**
       * @description: 搜索（方法描述）
       */
      onSearch(){

      },
      /**
       * @description: 删除（方法描述）
       */
      onDelete(id){

      },
      /**
       * @description: 表格页数切换（方法描述）
       */
      handleTableChange(pagination, filters, sorter){

      },
      /**
       * @description: 新增部门（方法描述）
       */
      onAddDepart(){
          this.isShowModel = true
      },
      /**
       * @description: 保存（方法描述）
       */
      onCofrimForm(){
          this.isShowModel = false
          this.form.validateFields((err, values) => {
              if(!err){
                  console.log(values)
              }
          })
      },
      /**
       * @description: 取消（方法描述）
       */
      onCancel(){
          this.isShowModel = false
      },
      /**
       * @description: 新增和编辑员工信息（方法描述）
       */
      onEdit(index,record){
          console.log(record)
          this.isShowModel1 = true
          if(index== 1){
            this.addNew = false
          }else{
            this.addNew = true
            this.$nextTick(()=>{
                this.form1.setFieldsValue({
                    data1: "352234",
                    data2: "销售部",
                    data3: "43252435",
                    data4: 0,
                    data5: 2,
                    data6: "32452435",
                    data7: "高中",
                    data8: "fdsg",
                    data9: 1,
                    data11: "sdgsdfg",
                    data12: "gdsfdgfsd",
                    name: "sadfdf",
                    phone: "4234543",
                })
                this.datetime = '2020-04-20'
                this.datetime1 = '2020-04-20'
            })
          }
      },
      /**
       * @description: 保存（方法描述）
       */
      onCofrimForm1(){
          this.form1.validateFields((err, values) => {
              if(!err){
                  values.data10 = this.datetime1
                  values.time = this.datetime
                  console.log(values)
                  // this.isShowModel1 = false
              }
          })
      },
      /**
       * @description: 取消（方法描述）
       */
      onCancel1(){
          this.isShowModel1 = false
      },
      /**
       * @description: 入职日期（方法描述）
       */
      onChangeData(date, dateString){
          console.log(date,dateString)
          this.datetime = dateString
      },
      /**
       * @description: 出生年月（方法描述）
       */
      onChangeData1(date, dateString){
          console.log(date,dateString)
          this.datetime1 = dateString
      },
      /**
       * @description: 是否正式（方法描述）
       */
      onChangeRadio(e){
          console.log(e.target.value)
      },
      /**
       * @description: 状态（方法描述）
       */
      onChangeRadio1(e){
          console.log(e.target.value)
      },
      /**
       * @description: 性别（方法描述）
       */
      onChangeRadio2(e){
          console.log(e.target.value)
      },
      /**
       * @description: 鼠标移入（方法描述）
       */
      mouseOver(e,item){
          this.treeList.forEach((item1)=>{
              item1.isCheck = false
          })
          item.isCheck = true

      },
      /**
       * @description: 鼠标移出（方法描述）
       */
      mouseLeave(e,item){
          item.isCheck = false
      },
      onEditTree(item){
          item.isActive = !item.isActive
          if(!item.isActive){
              Vue.directive('focus',{
                  inserted:function (el) {
                      el.focus()
                  }
              })
          }
      },
      /**
       * @description: 编辑失去焦点（方法描述）
       */
      onBlur(item){
          if(!this.isEmpty(item.name)){
              item.isActive = false
          }else{
              this.$message.warn('请输入内容')
          }
      },
      pressEnter(item){
          if(!this.isEmpty(item.name)){
              item.isActive = false
          }else{
              this.$message.warn('请输入内容')
          }
      },
  },
  watch: {

  },
  mounted () {

  },
  created () {

  }
}
</script>
<style lang="scss">
    .department{
        .ant-tree li{
            line-height: 36px;
            padding: 0 !important;
        }
        .ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper::before, .ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper::before{
            height: 36px !important;
        }
        .ant-tree li span.ant-tree-switcher, .ant-tree li span.ant-tree-iconEle{
            line-height: 30px !important;
        }
        .ant-tree li .ant-tree-node-content-wrapper{
            line-height: 36px !important;
            flex: 1;
            height: 36px;
            width: 100%;
        }
        .ant-tree-title{
            width: 75%;
            display: inline-block;
        }
        .tree-span{
            width: 100%;
            display: inline-block;
        }
        .form-left{
            flex: 1;
            padding-left: 40px;
            .ant-input{
                width: 200px;
            }
            .ant-col-12{
                padding-left: 20px;
                width: 55%;
            }
        }
        .model-form{
            .model-footer{
                padding-left: 18% !important;
            }
        }
        .down-up{
            width:120px;
            height:40px;
            border:1px solid #DDDDDD;
            border-radius:2px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .down-up-icon{
                color: #AAAAAA;
                padding-right: 5px;
            }
            .input-file{
                position: absolute;
                top: 0;
                left: 0;
                width: 120px;
                height: 40px;
                display: inline-block;
                opacity: 0;
            }
        }
        .ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before{
            background: rgba(55,122,252,0.1)!important;
        }
        .ant-tree-node-content-wrapper.ant-tree-node-selected{
            color: #333333!important;
        }
        /*.ant-input{*/
            /*height: 40px !important;*/
            /*line-height: 40px !important;*/
        /*}*/
        .tree-input{
            .ant-input{
                height: 28px !important;
                line-height:28px !important;
            }
        }
    }
</style>
<style lang="scss" scoped>
  .page-container{
      background: #FFFFFF;
      padding: 0;
  }
  .page-container-height{
      display: flex;
      .department-left{
          flex: 0 0 190px;
          border-right: 1px solid #EBF2FF;
          padding-top: 40px;
          .department-left-top{
              padding-left: 20px;

          }
      }
      .department-right{
          flex: 1;
          padding: 30px 33px 0 20px;
          .department-right-top{
              padding-bottom: 20px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              .department-top-left{
                  display: flex;
                  .department-input{
                      width: 260px;
                      margin-right: 16px;
                  }
              }
          }
          .operation{
              display: flex;
              justify-content: center;
              .operation-left{
                  color: #387BFC;
                  margin-right: 10px;
                  cursor: pointer;
              }
              .operation-right{
                  cursor: pointer;
              }
          }
      }
  }
  .upload-img{
      display: flex;
      align-items: center;
      justify-content: center;
      .upload-img-left{
          position: relative;
          img{
              width: 100px;
              height: 100px;
          }
          .upload-delete{
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100px;
              height: 24px;
              background:rgba(0,0,0,0.3);
              display: flex;
              justify-content: flex-end;
              align-items: center;
              .upload-delete-icon{
                  color: #FFFFFF;
                  font-size: 16px;
                  padding-right: 6px;
              }
          }
      }
      .upload-more{
          color: #387BFC;
          font-size: 14px;
          position: relative;
          padding-left: 10px;
          .input-file{
              display: inline-block;
              position: absolute;
              top: 0;
              left: 0;
              opacity: 0;
              width: 56px;
              height: 40px;
          }
      }
  }
  .tree-span{
      img{
          width: 11px;
          height: 12px;
          margin-left: 8px;
      }
      .tree-input{
          width: 100px;
          height: 28px !important;
          line-height: 28px !important;
      }
  }
</style>
